import "./tribunal-etica.scss";

export default function ComisionRevisora() {
  return (
    <section id="comision-revisora" className="section te-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>Comisión Revisora de Cuentas</h2>
        <p>
          Órgano encargado de fiscalizar la gestión económica y financiera del
          Colegio de Fonoaudiólogos de La Pampa — Período vigente.
        </p>
      </div>

      <div className="container fade-up">
        <div className="te-table-wrap">
          <table className="te-table">
            <tbody>
              <tr className="te-table__subheader">
                <td colSpan={2}>
                  <i className="bi bi-people-fill"></i> Titulares
                </td>
              </tr>
              <tr>
                <td className="te-table__cargo">Titular</td>
                <td className="te-table__nombre">Stock Capella, Victoria</td>
              </tr>
              <tr>
                <td className="te-table__cargo">Titular</td>
                <td className="te-table__nombre">Perez, Virginia</td>
              </tr>

              <tr className="te-table__subheader">
                <td colSpan={2}>
                  <i className="bi bi-person-lines-fill"></i> Suplentes
                </td>
              </tr>
              <tr>
                <td className="te-table__cargo">Suplente</td>
                <td className="te-table__nombre">Biscayart, Carla</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
